export default class ViewSimpleVideoVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------
	
	name = "Video";
	fieldType = 'simpleVideo';
	uiComponent = 'view-simple-video-field';
	description = 'Simply upload a single video.';

	constructor()
	{
		
	}
}